<div mat-dialog-title>
    <mat-icon>warning</mat-icon>
    <h1>{{ 'NoActiveUserLogoutDialog.Title' | translate }}</h1>
</div>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="primary">{{ 'NoActiveUserLogoutDialog.ExtendSessions' | translate }}</button>
</mat-dialog-actions>